import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { setToStartOfMonth } from 'helpers/date';
import { checkValueIncluded } from 'models/validate';
import { OTHER } from 'constants/enums/legalOptions';
import { isPVQForm } from 'helpers/form';
import pvqInvestigatingAgency from 'forms/shared/validators/models/pvqInvestigatingAgency/pvqInvestigatingAgency';
import { LegalInvestigationsRevokedItemModel } from '../types';

export const legalInvestigationsRevokedItemValidator: ValidateJSModel<LegalInvestigationsRevokedItemModel> = {
  Date: (value, attributes, attributeName, options = {}) => {
    if (isPVQForm(options?.formType) && attributes?.DateNotApplicable?.applicable === false) {
      return {};
    }

    const { applicantBirthdate } = options;

    return {
      presence: true,
      date: { earliest: setToStartOfMonth(applicantBirthdate), latest: DEFAULT_LATEST },
    };
  },
  Agency: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, model: { validator: pvqInvestigatingAgency } };
    }

    // At first glance you may think these 2 can be joined under the same conditional, but they should be separate. If not PVQ, we need to check the applicable value
    if (attributes?.AgencyNotApplicable?.applicable !== false) {
      return { presence: true, hasValue: true };
    }

    return {};
  },
  AgencyExplanation: (value, attributes, attributeName, options = {}) => {
    if (isPVQForm(options?.formType) && checkValueIncluded(attributes?.Agency, [OTHER])) {
      return { presence: true, hasValue: true };
    }

    return {};
  },
  Explanation: { presence: true, hasValue: true },
  AgencyNotApplicable: {},
  DateNotApplicable: {}
};
